import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../theme/ISpcTheme';

const postcodeLabelStyles = makeStyles<ISpcTheme>(theme => ({
  labelContainer: {
    marginTop: '2rem',
  },
  change: {
    marginLeft: '1.5rem',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export default postcodeLabelStyles;
